import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';

export interface SeparatedDiscounts {
  employeeDiscount?: number;
  geicoDiscount?: number;
  priceReductions?: number;
}

export default function separateDiscounts(
  discounts: Discount[],
  enableGeicoDiscount: boolean
): SeparatedDiscounts {
  const result = discounts.reduce(
    (acc, discount) => {
      if (discount.type === DiscountType.EmployeeDiscount) {
        acc.employeeDiscount += discount.amount;
      } else if (
        enableGeicoDiscount &&
        discount.type === DiscountType.GeicoTotalLoss
      ) {
        acc.geicoDiscount += discount.amount;
      } else {
        acc.priceReductions += discount.amount;
      }

      return acc;
    },
    { employeeDiscount: 0, geicoDiscount: 0, priceReductions: 0 }
  );

  return {
    employeeDiscount:
      result.employeeDiscount > 0 ? result.employeeDiscount : undefined,
    geicoDiscount: result.geicoDiscount > 0 ? result.geicoDiscount : undefined,
    priceReductions:
      result.priceReductions > 0 ? result.priceReductions : undefined
  };
}
